// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import Accordion from 'client/components/accordion/accordion';
import HeroContainer from 'client/components/heroContainer';
import HealthEntryPoint from 'client/components/ifpApp/healthEntryPoint';
import Panel from 'client/components/accordion/panel';
import CONTENTFUL_ENTRY_ID from 'client/constants/contentfulEntry';
import {
  COVID19_HEALTH_TAB_CLICK,
  COVID19_HEALTH_ZIP_CODE_SEARCH,
} from 'client/constants/amplitudeTracker';
import { Tracking } from 'web-core/src/tracking';
import IntroSection, { type IntroType } from './shared/introSection';
import ResourcesNav, { type NavType } from './shared/resourcesNav';
import { trackAccordionClick } from './utils/tracking';

import '../styles/guidePage.scss';

type Props = {
  fetchContentful: Function,
  contentfulData: {
    accordion: Array<{
      title: string,
      content: string,
    }>,
    accordionHeader: string,
    hero: Object,
    intro: IntroType,
    nav: NavType,
    zipCodeSearch: {
      header: string,
      description: string,
    },
  },
};

class HealthGuide extends Component<Props> {
  componentDidMount() {
    this.props.fetchContentful(CONTENTFUL_ENTRY_ID.COVID_19_HEALTH_GUIDE);
  }

  render() {
    const {
      contentfulData: { accordion, accordionHeader, hero, intro, nav, zipCodeSearch },
    } = this.props;

    if (!accordion) return null;

    return (
      <div className="health-guide-page guide-page-container">
        <HeroContainer base="health-guide" {...hero} />
        <div className="content-container">
          {intro && <IntroSection intro={intro} />}
          <div className="gray-content-box">
            <h4 className="header bold pad-y">{zipCodeSearch.header}</h4>
            <div className="pad-bottom">{zipCodeSearch.description}</div>
            <HealthEntryPoint
              onClick={value => Tracking.track(COVID19_HEALTH_ZIP_CODE_SEARCH, { zipcode: value })} />
          </div>
          <h3 className="pad-y-2">{accordionHeader}</h3>
          <Accordion onChange={state => trackAccordionClick(COVID19_HEALTH_TAB_CLICK, state)}>
            {_.map(accordion, item => (
              <Panel key={item.title} title={<span>{item.title}</span>}>
                <div dangerouslySetInnerHTML={{ __html: `${item.content}` }} />
              </Panel>
            ))}
          </Accordion>
          {nav && <ResourcesNav nav={nav} />}
        </div>
      </div>
    );
  }
}

export default HealthGuide;
